(function () {
  var button = document.querySelector('[data-shop-menu-button]');
  var menu = document.querySelector('[data-shop-mobile-nav]');
  var header = document.querySelector('[data-shop-header]');

  if (button && menu) {
    button.addEventListener('click', function () {
      var isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
      document.body.classList.toggle('shop-menu-open', !isOpen);
    });

    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) {
        button.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
        document.body.classList.remove('shop-menu-open');
      }
    });
  }

  function updateHeader() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 12);
  }
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.product-card, .shop-assurance > div').forEach(function (element) {
      element.classList.add('shop-reveal');
      observer.observe(element);
    });
  }
})();
